/* Shopify consent banner compactor — JS applies inline styles directly */
(function () {
  function compact(el) {
    if (el._coraCompact) return;
    el._coraCompact = true;
    function sp(k, v) {
      el.style.setProperty(k, v, 'important');
    }
    sp('position', 'fixed');
    sp('bottom', '0');
    sp('left', '0');
    sp('right', '0');
    sp('top', 'auto');
    sp('height', '48px');
    sp('max-height', '48px');
    sp('overflow', 'hidden');
    sp('display', 'flex');
    sp('align-items', 'center');
    sp('padding', '0 16px');
    sp('gap', '12px');
    sp('flex-wrap', 'nowrap');
    sp('box-sizing', 'border-box');
    sp('background', '#faf6f1');
    sp('border-top', '1px solid #e8ddd4');
    sp('z-index', '9999');

    const wrapper = el.querySelector('.shopify-pc__banner__wrapper');
    if (wrapper) wrapper.style.setProperty('display', 'contents', 'important');

    const body = el.querySelector('.shopify-pc__banner__body');
    if (body) {
      body.style.setProperty('display', 'flex', 'important');
      body.style.setProperty('align-items', 'center', 'important');
      body.style.setProperty('flex', '1 1 auto', 'important');
      body.style.setProperty('min-width', '0', 'important');
      body.style.setProperty('overflow', 'hidden', 'important');
    }

    el.querySelectorAll('h1,h2,h3').forEach(function (h) {
      h.style.setProperty('display', 'none', 'important');
    });

    el.querySelectorAll('p').forEach(function (p) {
      p.style.setProperty('font-size', '0.72rem', 'important');
      p.style.setProperty('white-space', 'nowrap', 'important');
      p.style.setProperty('overflow', 'hidden', 'important');
      p.style.setProperty('text-overflow', 'ellipsis', 'important');
      p.style.setProperty('flex', '1 1 auto', 'important');
      p.style.setProperty('min-width', '0', 'important');
      p.style.setProperty('margin', '0', 'important');
      p.style.setProperty('line-height', '1', 'important');
      p.querySelectorAll('a').forEach(function (a) {
        a.style.setProperty('display', 'none', 'important');
      });
    });

    const btns = el.querySelector('.shopify-pc__banner__btns');
    if (btns) {
      btns.style.setProperty('display', 'flex', 'important');
      btns.style.setProperty('gap', '6px', 'important');
      btns.style.setProperty('flex-shrink', '0', 'important');
      btns.style.setProperty('align-items', 'center', 'important');
    }

    el.querySelectorAll('button').forEach(function (b) {
      if (b.id === 'shopify-pc__banner__btn-manage-prefs') {
        b.style.setProperty('display', 'none', 'important');
        return;
      }
      b.style.setProperty('padding', '4px 10px', 'important');
      b.style.setProperty('font-size', '0.7rem', 'important');
      b.style.setProperty('white-space', 'nowrap', 'important');
      b.style.setProperty('min-height', '0', 'important');
      b.style.setProperty('height', 'auto', 'important');
      b.style.setProperty('line-height', '1', 'important');
      if (b.id === 'shopify-pc__banner__btn-accept') {
        b.style.setProperty('background', '#c29392', 'important');
        b.style.setProperty('color', '#fff', 'important');
        b.style.setProperty('border', '1px solid #c29392', 'important');
      } else {
        b.style.setProperty('background', 'transparent', 'important');
        b.style.setProperty('color', '#4a3728', 'important');
        b.style.setProperty('border', '1px solid #c8b5a8', 'important');
      }
    });
  }

  function check() {
    const el = document.getElementById('shopify-pc__banner');
    if (el) compact(el);
  }

  check();
  new MutationObserver(check).observe(document.documentElement, { childList: true, subtree: true });
})();
